import { UserType } from './enum.model';
export class RegisterUserModel {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  type: UserType;
  municipalities: string[];
  categories: string[];
}

export class RegisterResponseModel {
  status: string;
  message: string;
}
